import React, { useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from '../../../../hooks/useTranslation';
import { BaseFormModel } from '../../../../hooks/useFormState.types';
import TextField from '../../../text-field';
import {
  PersonalIdentificationType,
  StateIdType,
  FederalIdentificationType,
} from '../../../../__generated__/pge-types';
import { Box } from '@material-ui/core';

type Props = {
  form: BaseFormModel;
  primaryIdType: PersonalIdentificationType;
  isCoCustomer?: boolean;
};

export interface IdTypeMap<TValue> {
  [id: string]: TValue;
}

export const idTypeMap: IdTypeMap<string> = {
  [PersonalIdentificationType.Ssn]: 'SOCIAL_SECURITY_NUMBER',
  [PersonalIdentificationType.Dl]: 'DL_OR_STATE_ID',
  [StateIdType.DriverLicense]: 'DL_OR_STATE_ID',
  [StateIdType.StateIdCard]: 'DL_OR_STATE_ID',
  [PersonalIdentificationType.Ortrib]: 'OREGON_TRIBAL_ID',
  [FederalIdentificationType.OregonTribalId]: 'OREGON_TRIBAL_ID',
  [PersonalIdentificationType.Visa]: 'VISA_ID_TEMP_STUDENT',
  [PersonalIdentificationType.Matr]: 'MATRICULA_ID',
  [FederalIdentificationType.UsStudentVisa]: 'VISA_ID_TEMP_STUDENT',
  [FederalIdentificationType.UsTemporaryVisa]: 'VISA_ID_TEMP_STUDENT',
  [PersonalIdentificationType.Military]: 'MILITARY_ID',
  [FederalIdentificationType.UsMilitaryId]: 'MILITARY_ID',
  [PersonalIdentificationType.Pssprt]: 'PASSPORT',
  [FederalIdentificationType.UsPassport]: 'PASSPORT',
  [PersonalIdentificationType.Resalien]: 'RESIDENT_ALIEN_ID',
  [FederalIdentificationType.UsImmigration]: 'RESIDENT_ALIEN_ID',
  [PersonalIdentificationType.Itin]: 'ITIN',
  [PersonalIdentificationType.Duns]: 'DUNS',
  [PersonalIdentificationType.Ein]: 'EIN',
  [PersonalIdentificationType.Wrksch]: 'WRKSCH',
  [PersonalIdentificationType.Essid]: 'ESSID',
};

const VerifyExistingCustomerIdentity = ({
  form,
  primaryIdType,
  isCoCustomer = false,
}: Props) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (primaryIdType && primaryIdType !== PersonalIdentificationType.None) {
      form.setValue('idType', primaryIdType);
    }
  }, [primaryIdType]);

  const getIdTypeLabel = (): string => {
    return t(idTypeMap[primaryIdType] || '');
  };

  return (
    <Grid container spacing={2} justify="center">
      <Grid item xs={12}>
        <Typography component="p" align="center">
          {isCoCustomer
            ? t('ENTER_THE_LAST_FOUR_DIGITS_OF_THEIR')
            : t('ENTER_THE_LAST_FOUR_DIGITS_OF_YOUR')}{' '}
          <strong>{getIdTypeLabel()}.</strong>
        </Typography>
      </Grid>

      <Grid item xs={12} md={6}>
        <Box mb={5}>
          <TextField
            inputProps={{ maxLength: 4, minLength: 1 }}
            name="idValue"
            {...form.props('idValue')}
            delayedTextMask={true}
            error={Boolean(form.errors.idValue)}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default VerifyExistingCustomerIdentity;
